import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-check d-inline-block" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "card-body"
}
const _hoisted_5 = { class: "text-muted small" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap align-items-center gap-3 mb-3"
}
const _hoisted_7 = { class: "small text-muted" }
const _hoisted_8 = {
  key: 2,
  class: "text-muted mb-3"
}
const _hoisted_9 = { class: "col-xl-2 col-lg-3 col-sm-4 col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_picker = _resolveComponent("file-picker")!
  const _component_attachment_control = _resolveComponent("attachment-control")!
  const _component_upload_tile = _resolveComponent("upload-tile")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_photo_lightbox = _resolveComponent("photo-lightbox")!
  const _component_undo_toast = _resolveComponent("undo-toast")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header", {'cursor-move': _ctx.checked}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: _ctx.attachmentType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attachmentTypeModel) = $event))
        }, null, 8, _hoisted_2), [
          [_vModelCheckbox, _ctx.attachmentTypeModel]
        ]),
        _createElementVNode("label", {
          class: "form-check-label ms-2 w-100",
          for: _ctx.attachmentType
        }, _toDisplayString(_ctx.translateType(_ctx.attachmentType)), 9, _hoisted_3)
      ])
    ], 2),
    (_ctx.checked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rejectedNames, (name) => {
            return (_openBlock(), _createElementBlock("div", {
              key: name,
              class: "alert alert-danger"
            }, [
              _cache[2] || (_cache[2] = _createTextVNode(" Typ souboru ", -1)),
              _createElementVNode("strong", null, _toDisplayString(name), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" není podporován. ", -1))
            ]))
          }), 128)),
          (_ctx.uploadedAttachments.length === 0 && _ctx.uploads.length === 0)
            ? (_openBlock(), _createBlock(_component_file_picker, {
                key: 0,
                compact: false,
                "button-label": "Přidat soubory",
                "button-class": "btn-outline-primary btn-sm",
                "accepted-types": _ctx.SUPPORTED_ATTACHMENT_TYPES,
                onSelected: _ctx.filesSelected
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-semibold d-block" }, "Přetáhněte sem soubory přílohy", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted small d-block" }, "nebo klikněte a vyberte je", -1)),
                  _createElementVNode("span", _hoisted_5, "Obrázky nebo PDF nejvýš o " + _toDisplayString(_ctx.MAX_PDF_PAGES) + " stranách, každá strana PDF bude samostatný soubor.", 1)
                ]),
                _: 1
              }, 8, ["accepted-types", "onSelected"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_file_picker, {
                  compact: true,
                  "button-label": "Přidat soubory",
                  "button-class": "btn-outline-primary btn-sm",
                  "accepted-types": _ctx.SUPPORTED_ATTACHMENT_TYPES,
                  onSelected: _ctx.filesSelected
                }, null, 8, ["accepted-types", "onSelected"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.summary), 1)
              ])),
          (_ctx.isBusy)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm me-2 align-middle",
                  role: "status"
                }, null, -1)),
                _createTextVNode(" Nahráno " + _toDisplayString(_ctx.doneCount) + " z " + _toDisplayString(_ctx.totalCount) + ". ", 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.uploadedAttachments.length > 0 || _ctx.uploads.length > 0)
            ? (_openBlock(), _createBlock(_component_draggable, {
                key: 3,
                modelValue: _ctx.uploadedAttachments,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploadedAttachments) = $event)),
                class: "row g-3",
                "item-key": "id",
                handle: ".photo-tile-thumb",
                disabled: _ctx.isBusy,
                onEnd: _ctx.onDragEnd
              }, {
                item: _withCtx(({element: attachment, index}) => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_attachment_control, {
                      attachment: attachment,
                      order: index + 1,
                      onOpen: ($event: any) => (_ctx.lightbox?.open(index)),
                      onRemove: ($event: any) => (_ctx.removeLater([attachment], 'Soubor přílohy smazán.'))
                    }, null, 8, ["attachment", "order", "onOpen", "onRemove"])
                  ])
                ]),
                footer: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploads, (upload) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-xl-2 col-lg-3 col-sm-4 col-6",
                      key: upload.key
                    }, [
                      _createVNode(_component_upload_tile, {
                        upload: upload,
                        onRetry: ($event: any) => (_ctx.retry(upload.key)),
                        onDiscard: ($event: any) => (_ctx.discard(upload.key))
                      }, null, 8, ["upload", "onRetry", "onDiscard"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "onEnd"]))
            : _createCommentVNode("", true),
          _createVNode(_component_photo_lightbox, {
            ref: "lightbox",
            items: _ctx.uploadedAttachments.map(attachment => ({id: attachment.id, url: attachment.url, description: ''})),
            "title-badge": false,
            "can-describe": false,
            "can-rotate": false,
            "rotating-ids": []
          }, null, 8, ["items"]),
          _createVNode(_component_undo_toast, {
            message: _ctx.removalMessage,
            onUndo: _ctx.undoRemoval
          }, null, 8, ["message", "onUndo"])
        ]))
      : _createCommentVNode("", true)
  ]))
}